import { render, staticRenderFns } from "./wtBeatsButton.vue?vue&type=template&id=548268d3&scoped=true&"
import script from "./wtBeatsButton.vue?vue&type=script&lang=js&"
export * from "./wtBeatsButton.vue?vue&type=script&lang=js&"
import style0 from "./wtBeatsButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wtBeatsButton.vue?vue&type=style&index=1&id=548268d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548268d3",
  null
  
)

export default component.exports